import { useEffect, useRef } from 'react'
import { Loader } from '@googlemaps/js-api-loader'

import selectedPoiIcon from '../public/common/Icon_POI_selected_m.svg'
import unselectedPoiIcon from '../public/common/Icon_POI_unselected_m.svg'

interface IMapProps {
  selectMarker(marker: Number): void
  markerList: any[]
  className?: string
  center?: { lat: number; lng: number }
}

const MapPlan = ({
  selectMarker,
  markerList,
  className,
  center,
}: IMapProps) => {
  let activeInfoBox: google.maps.InfoWindow
  const googlemap = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const loader = new Loader({
      apiKey: 'AIzaSyCCzpQxRX6qnFZqfBIMi2byP0ZDEPt6Y4U',
    })
    let map: google.maps.Map
    loader.load().then(() => {
      const google = window.google
      if (googlemap.current) {
        map = new google.maps.Map(googlemap.current, {
          center: center ?? { lat: 47.4443956, lng: 19.1740384 },
          zoom: 12,
          disableDefaultUI: true,
        })
        markerList.forEach((marker) => {
          const m = new google.maps.Marker({
            position: {
              lat: isNaN(marker.lat)
                ? Number.parseFloat(marker.lat)
                : marker.lat,
              lng: isNaN(marker.lon)
                ? Number.parseFloat(marker.lon)
                : marker.lon,
            },
            map: map,
          })
          if (marker.isActive) {
            m.setIcon(selectedPoiIcon.src)
          } else {
            m.setIcon(unselectedPoiIcon.src)
          }
          const iv = new google.maps.InfoWindow({
            content: marker.address,
          })
          google.maps.event.addListener(
            m,
            'click',
            (function (p) {
              return function () {
                iv.open({
                  anchor: p,
                  map,
                  shouldFocus: false,
                })
                activeInfoBox && activeInfoBox.close()
                // eslint-disable-next-line react-hooks/exhaustive-deps
                activeInfoBox = iv
                selectMarker(marker.id)
              }
            })(m)
          )
        })
      }
    })
  })

  return (
    <div
      id="map"
      ref={googlemap}
      className={className ?? `h-[600px] mb-[40px]`}
    ></div>
  )
}

export default MapPlan
